export default __webpack_public_path__ + "static/media/img5.07080d3b.jpg";